import styled, { css, keyframes } from 'styled-components';
import { C as ClassNamePassthrough } from '../LocalModules/storm-ui-utils/dist/esm/ClassNamePassthrough-BOut0eKj-BOut0eKj.js';

const pulseAnimation = /*#__PURE__*/keyframes(["0%{/*! @noflip */ transform:rotate(0deg);}100%{/*! @noflip */ transform:rotate(360deg);}"]);
const pulseStyle = /*#__PURE__*/css(["animation-duration:1s;animation-timing-function:steps(8);animation-delay:0s;animation-iteration-count:infinite;animation-direction:normal;animation-fill-mode:none;animation-play-state:running;animation-name:", ";"], pulseAnimation);
const IconClassWrapper = /*#__PURE__*/styled(ClassNamePassthrough).withConfig({
  componentId: "sc-storm-ui-30065889__sc-1gsqp3h-0"
})(["height:1em;:not(:root){overflow:visible;}", " ", ";vertical-align:", "em;"], ({
  $pulse
}) => $pulse ? pulseStyle : null, ({
  $fontSize
}) => $fontSize ? `font-size: ${$fontSize}` : null, ({
  $size
}) => $size === 'lg' ? '-0.225' : '-0.125');
const IconWrapperStyled = /*#__PURE__*/styled('i').withConfig({
  componentId: "sc-storm-ui-30065889__sc-1gsqp3h-1"
})(["", " ", ""], ({
  $blockSize
}) => $blockSize ? css(["display:inline-block;> svg{display:block;}"]) : '',
// Only use the icon RTL flipper when using a logical direction icon type;
({
  $horizontalFlipOnRTL
}) => $horizontalFlipOnRTL ? css(["/*! @noflip */ [dir=\"rtl\"] && > svg{/*! @noflip */ transform:scaleX(-1);}"]) : '');

export { IconClassWrapper as I, IconWrapperStyled as a };
//# sourceMappingURL=Icon.styles-Bb9aDlfj.js.map
